// removed by extract-text-webpack-plugin
module.exports = {"box":"qempo_UnconfirmedPayment_box-15vM8Nv","courier":"qempo_UnconfirmedPayment_courier-2VvhjBZ","change":"qempo_UnconfirmedPayment_change-7uUVd8k","buttonsWrap":"qempo_UnconfirmedPayment_buttonsWrap-34uagK_","below":"qempo_UnconfirmedPayment_below-yDAAz5Y"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/Purchase/unconfirmed-payment/components/UnconfirmedPayment.scss
// module id = 1801
// module chunks = 0